module.exports = __webpack_public_path__ + "img/DE00109.f476e5d5.svg";